import { axios } from "@/plugins/axios";
import { merge } from "lodash";

export default class TriggersService
{
    public static async ExecuteScript(licence: string, id: string, scriptId: string, scriptConfigId: string, formId: string, tableRowIndex: number | null, model: Record<string, unknown>, baseModel: Record<string, unknown>): Promise<any>
    {
        const action = id.split('/').length > 1 ? 'bpmn-execute' : 'bpmn-start';

        return (await axios.post(`dynamic-modal/${licence}/${id}/${action}/script/${scriptId}`, {
            formData: model,
            baseFormData: baseModel
        }, {
            params: merge({
                formId: formId,
                scriptConfigId: scriptConfigId,
                tableRowIndex,
                withValidation: false
            })
        })).data;
    }
}
